import { render, staticRenderFns } from "./DefaultHeaderDropdownAutomicvehicle.vue?vue&type=template&id=224fd967&scoped=true"
import script from "./DefaultHeaderDropdownAutomicvehicle.vue?vue&type=script&lang=js"
export * from "./DefaultHeaderDropdownAutomicvehicle.vue?vue&type=script&lang=js"
import style0 from "./DefaultHeaderDropdownAutomicvehicle.vue?vue&type=style&index=0&id=224fd967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224fd967",
  null
  
)

export default component.exports